
export default {
    head: {
        bodyAttrs: {
            dir: 'ltr',
        },
    },
}
